import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import gearIcon from "assets/images/icons/portal-order/gear.svg";
import "./style.css";

const progressTexts = [
  { min: 0, max: 20, text: "Pengecekan/pembuatan akun", duration: 5000 }, // 5 detik
  { min: 20, max: 40, text: "Kalkulasi keranjang belanja", duration: 5000 }, // 5 detik
  { min: 40, max: 60, text: "Penerapan Diskon", duration: 3000 }, // 5 detik
  { min: 60, max: 80, text: "Pengiriman informasi ke WA & Email", duration: 3000 }, // 5 detik
  { min: 80, max: 100, text: "Sedikit lagi Selesai...", duration: 3000 }, // 3 detik
];
// Total: 23 detik

const ModalOrderProgress = ({ show, onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [currentText, setCurrentText] = useState(progressTexts[0].text);
  const intervalRef = useRef(null);
  const startTimeRef = useRef(null);
  const currentStageRef = useRef(0);

  useEffect(() => {
    // Clear any existing interval first
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }

    if (show) {
      setProgress(0);
      setCurrentText(progressTexts[0].text);
      currentStageRef.current = 0;
      startTimeRef.current = Date.now();

      // Start progress animation with variable speed per stage
      intervalRef.current = setInterval(() => {
        const elapsed = Date.now() - startTimeRef.current;
        let totalElapsed = 0;
        let newProgress = 0;
        let currentStage = 0;

        // Calculate which stage we're in based on elapsed time
        for (let i = 0; i < progressTexts.length; i++) {
          const stageDuration = progressTexts[i].duration;
          if (elapsed < totalElapsed + stageDuration) {
            // We're in this stage
            currentStage = i;
            const stageElapsed = elapsed - totalElapsed;
            const stageProgress = (stageElapsed / stageDuration) * (progressTexts[i].max - progressTexts[i].min);
            newProgress = progressTexts[i].min + stageProgress;
            break;
          }
          totalElapsed += stageDuration;
          newProgress = progressTexts[i].max;
        }

        // Clamp to 100 and round to integer
        if (newProgress >= 100) {
          newProgress = 100;
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }
        }

        // Round progress to integer to avoid decimal display
        setProgress(Math.round(newProgress));
        currentStageRef.current = currentStage;
      }, 50); // Update every 50ms for smoother animation
    } else {
      // Reset only when modal is closed
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      setProgress(0);
      setCurrentText(progressTexts[0].text);
      currentStageRef.current = 0;
      startTimeRef.current = null;
    }

    // Cleanup on unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [show, onComplete]);

  // Update current text based on progress
  useEffect(() => {
    const current = progressTexts.find(
      (item) => progress >= item.min && progress < item.max
    );
    if (current) {
      setCurrentText(current.text);
    } else if (progress >= 100) {
      setCurrentText(progressTexts[progressTexts.length - 1].text);
    }
  }, [progress]);

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      className="modal-order-progress"
    >
      <Modal.Body className="text-center p-4">
        <div className="progress-modal-content">
          <div className="progress-icon-wrapper">
            <img
              className="gear-rotate"
              src={gearIcon}
              alt="gear.svg"
              width="70px"
              height="70px"
            />
          </div>

          <div className="progress-bar-container mb-3">
            <div className="progress-bar-wrapper">
              <div
                className="progress-bar-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
            <div className="progress-percentage">{Math.round(progress)}%</div>
          </div>

          <p className="progress-text">{currentText}</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalOrderProgress;

